import { Period } from "../types";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export async function getPeriods(): Promise<Period[]> {
  let resp = await fetch(`${API_URL}/periods`);

  if (!resp.ok) {
    throw new Error(`Request failed with status ${resp.status}`);
  }

  let data: Period[] = await resp.json();
  return data;
}

export async function getPeriod(id: number): Promise<Period> {
  let resp = await fetch(`${API_URL}/periods/${id}`);

  if (!resp.ok) {
    throw new Error(`Request failed with status ${resp.status}`);
  }

  let data: Period = await resp.json();
  return data;
}

export async function insertPeriod(period: {
  name?: string;
  start_date: string;
  end_date?: string;
}): Promise<Period> {
  let resp = await fetch(`${API_URL}/periods`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(period),
  });

  if (!resp.ok) {
    throw new Error(`Request failed with status ${resp.status}`);
  }

  let data: Period = await resp.json();
  return data;
}

export async function updatePeriod(period: Period): Promise<Period> {
  let resp = await fetch(`${API_URL}/periods/${period.id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(period),
  });

  if (!resp.ok) {
    throw new Error(`Request failed with status ${resp.status}`);
  }

  let data: Period = await resp.json();
  return data;
}

export async function deletePeriod(period_id: number) {
  let resp = await fetch(`${API_URL}/periods/${period_id}`, {
    method: "DELETE",
  });

  if (!resp.ok) {
    throw new Error(`Request failed with status ${resp.status}`);
  }

  let data: { deleted: Period } = await resp.json();
  return data;
}
